import { useState, useEffect, useCallback } from "react";
import i18n from "../../utils/i18n";

const ShiftScheduleMemberTypePropertyFilterSelect = ({
  attributes,
  memberTypeProperties,
  onChange,
  onRemove,
}) => {
  const { member_type_property_id, required_value, required_number } =
    attributes;

  const [selectedId, setSelectedId] = useState(member_type_property_id);
  const [filterValue, setFilterValue] = useState(required_value);
  const [filterCount, setFilterCount] = useState(required_number);

  const getDefaultFilterValueForMemberTypeProperty = (memberTypeProperty) => {
    switch (memberTypeProperty.type) {
      case "MemberTypeProperties::CustomCheckbox":
        return true;
      case "MemberTypeProperties::CustomSelect":
        return Object.keys(memberTypeProperty.data.options)[0];
      case "MemberTypeProperties::CustomInteger":
        return 0;
      case "MemberTypeProperties::Birthdate":
        return 0;
      default:
        return null;
    }
  };

  const getSelectedMemberTypeProperty = useCallback(
    (id) => {
      let concatenatedMemberTypeProperties = [];

      Object.values(memberTypeProperties).forEach((memberTypeProps) => {
        concatenatedMemberTypeProperties =
          concatenatedMemberTypeProperties.concat(memberTypeProps);
      });

      return concatenatedMemberTypeProperties.find(
        (memberTypeProperty) => memberTypeProperty.id == id
      );
    },
    [memberTypeProperties]
  );

  const propagateOnChange = useCallback(
    (updates) => {
      const newState = {
        selectedId,
        filterValue,
        filterCount,
        ...updates,
      };

      onChange(attributes.key, newState);
    },
    [selectedId, filterValue, filterCount, attributes.key, onChange]
  );

  // Update local state and propagate changes when state changes
  useEffect(() => {
    propagateOnChange({});
  }, [selectedId, filterValue, filterCount]);

  const handleSelectMemberTypeProperty = (event) => {
    const newSelectedId = parseInt(event.target.value);

    if (newSelectedId) {
      const selectedMemberTypeProperty =
        getSelectedMemberTypeProperty(newSelectedId);

      setSelectedId(newSelectedId);
      setFilterValue(
        getDefaultFilterValueForMemberTypeProperty(selectedMemberTypeProperty)
      );
    } else {
      setSelectedId(null);
      setFilterValue(null);
    }
  };

  const handleChangeFilterValue = (event) => {
    setFilterValue(event.target.value || null);
  };

  const handleChangeFilterCount = (event) => {
    setFilterCount(parseInt(event.target.value) || 0);
  };

  const renderFilterableMemberTypePropertyOptions = () => {
    return Object.keys(memberTypeProperties).map((memberType) => {
      return (
        <optgroup key={memberType} label={memberType}>
          {memberTypeProperties[memberType].map((memberTypeProperty) => {
            return (
              <option key={memberTypeProperty.id} value={memberTypeProperty.id}>
                {memberTypeProperty.name}
              </option>
            );
          })}
        </optgroup>
      );
    });
  };

  const renderFilter = () => {
    const selectedMemberTypeProperty =
      getSelectedMemberTypeProperty(selectedId);
    const type = selectedMemberTypeProperty?.type;

    switch (type) {
      case "MemberTypeProperties::CustomCheckbox":
        return <span> selected </span>;
      case "MemberTypeProperties::CustomInteger":
        return (
          <span>
            <span> of at least </span>
            <input
              value={filterValue}
              className="form-control input-sm"
              style={{ width: "50px", display: "inline-block" }}
              type="number"
              onChange={handleChangeFilterValue}
            />
          </span>
        );
      case "MemberTypeProperties::Birthdate":
        return (
          <div>
            <span> after </span>
            <input
              value={filterValue}
              className="form-control input-sm"
              style={{ width: "auto", display: "inline-block" }}
              type="date"
              onChange={handleChangeFilterValue}
            />
          </div>
        );
      case "MemberTypeProperties::CustomSelect":
        return (
          <span>
            <span> of </span>
            <select
              value={filterValue}
              className="form-control input-sm"
              style={{ width: "auto", display: "inline-block" }}
              onChange={handleChangeFilterValue}
            >
              {Object.entries(selectedMemberTypeProperty.data.options).map(
                ([index, value]) => {
                  return (
                    <option key={index} value={index}>
                      {value[i18n.locale]}
                    </option>
                  );
                }
              )}
            </select>
          </span>
        );
      default:
        return <span></span>;
    }
  };

  return (
    <div>
      <p>
        <button
          className="btn btn-warning pull-right"
          type="button"
          onClick={() => onRemove(attributes.key)}
        >
          Remove
        </button>
        <span> Must have at least </span>
        <input
          value={filterCount}
          className="form-control input-sm"
          style={{ width: "50px", display: "inline-block" }}
          onChange={handleChangeFilterCount}
        ></input>
        <span> members with the property </span>
      </p>
      <p>
        <select
          className="form-control input-sm"
          style={{ width: "auto", display: "inline-block" }}
          value={selectedId || ""}
          onChange={handleSelectMemberTypeProperty}
        >
          <option value="">Vælg en member type property</option>
          {renderFilterableMemberTypePropertyOptions()}
        </select>
        {renderFilter()}
      </p>
    </div>
  );
};

export default ShiftScheduleMemberTypePropertyFilterSelect;
